export default "__VITE_ASSET__CzoyDVqd__"